// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__hTnh0","panelToggle":"styles_panel-toggle__ERvf9"};